import AddressField from "./AddressField";
import AddressFieldLabel from "./AddressFieldLabel";

export default function AddressFieldWithLabel({
  initialAddress,
  label,
  initialPosition = "top",
  placeholder,
  fieldName,
  fieldValue,
  customOnChange,
  noClearIcon = false,
  defaultEditingMode = false,
}) {
  if (initialPosition === "left") {
    return (
      <div className="flex flex-row gap-1">
        <AddressFieldLabel label={label} />
        <AddressField
          initialAddress={initialAddress}
          fieldName={fieldName}
          fieldValue={fieldValue}
          customOnChange={customOnChange}
          hideLabel={true}
          defaultEditingMode={defaultEditingMode}
        />
      </div>
    );
  } else {
    return (
      <div className="flex flex-col gap-1">
        <AddressFieldLabel label={label} />
        <AddressField
          initialAddress={initialAddress}
          fieldName={fieldName}
          fieldValue={fieldValue}
          customOnChange={customOnChange}
          hideLabel={true}
          defaultEditingMode={defaultEditingMode}
        />
      </div>
    );
  }
}
